"use strict";
// Copyright (C) 2017-2023 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_dom_1 = require("react-dom");
var react_i18next_1 = require("react-i18next");
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var common_1 = require("stremio/common");
var components_1 = require("stremio/components");
var styles_less_1 = __importDefault(require("./styles.less"));
var ShortcutsModal = function (_a) {
    var onClose = _a.onClose;
    var t = (0, react_i18next_1.useTranslation)().t;
    var grouped = (0, common_1.useShortcuts)().grouped;
    (0, react_1.useEffect)(function () {
        var onKeyDown = function (_a) {
            var key = _a.key;
            key === 'Escape' && onClose();
        };
        document.addEventListener('keydown', onKeyDown);
        return function () { return document.removeEventListener('keydown', onKeyDown); };
    }, [onClose]);
    return (0, react_dom_1.createPortal)((react_1.default.createElement("div", { className: styles_less_1.default['shortcuts-modal'] },
        react_1.default.createElement("div", { className: styles_less_1.default['backdrop'], onClick: onClose }),
        react_1.default.createElement("div", { className: styles_less_1.default['container'] },
            react_1.default.createElement("div", { className: styles_less_1.default['header'] },
                react_1.default.createElement("div", { className: styles_less_1.default['title'] }, t('SETTINGS_NAV_SHORTCUTS')),
                react_1.default.createElement(components_1.Button, { className: styles_less_1.default['close-button'], title: t('BUTTON_CLOSE'), onClick: onClose },
                    react_1.default.createElement(react_2.default, { className: styles_less_1.default['icon'], name: 'close' }))),
            react_1.default.createElement("div", { className: styles_less_1.default['content'] }, grouped.map(function (_a) {
                var name = _a.name, label = _a.label, shortcuts = _a.shortcuts;
                return (react_1.default.createElement(components_1.ShortcutsGroup, { key: name, label: label, shortcuts: shortcuts }));
            }))))), document.body);
};
exports.default = ShortcutsModal;
